// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Management
const NewCSDashboard  = () => import('@/modules/customer_service/views/NewCSDashboard')
const NewRetentionDashboard  = () => import('@/modules/customer_service/views/NewRetentionDashboard')

const CSLeadPage = () => import('@/modules/customer_service/views/CSLeadPage')

const CSUnassignedList = () => import('@/modules/customer_service/views/CSUnassignedList');
const CSPastDueList = () => import('@/modules/customer_service/views/CSPastDueList');
const CSUrgentList = () => import('@/modules/customer_service/views/CSUrgentList');
const CSList = () => import('@/modules/customer_service/views/CSList')
const CSLossPreventionList = () => import('@/modules/customer_service/views/CSLossPreventionList');
const CSElavonComplaintList = () => import('@/modules/customer_service/views/CSElavonComplaintList');
const CSRetentionList = () => import('@/modules/customer_service/views/CSRetentionList');
const CSCallbackList = () => import('@/modules/customer_service/views/CSCallbackList');

const CSUntouchedTickets = () => import('@/modules/customer_service/views/CSUntouchedTickets');
const CSTicketsWithoutCallList = () => import('@/modules/customer_service/views/CSTicketsWithoutCallList');

const CSOrderList = () => import('@/modules/customer_service/views/CSOrderList');

const CSTaliupRegisterList = () => import('@/modules/customer_service/views/CSTaliupRegisterList');

const CSThirdAttemptCloseRequestList = () => import('@/modules/customer_service/views/CSThirdAttemptCloseRequestList');
const CSResolvedList = () => import('@/modules/customer_service/views/CSResolvedList');

const CSAdminTaskList = () => import('@/modules/customer_service/views/CSAdminTaskList');

const CSRequestToActionList = () => import('@/modules/customer_service/views/CSRequestToActionList');

const ManageCSEmailTemplatesList = () => import('@/modules/customer_service/views/management/ManageCSEmailTemplatesList');


var routes = [
    {
        path: '/customer-service',
        redirect: '/customer-service/new-dashboard',
        name: 'Customer Service',
        component: DefaultContainer,
        children: [
            {
				path: '/customer-service',
                name: 'CSLeadPage',
				redirect: '/customer-service/new-dashboard',
                component: CSLeadPage,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
				children: [
					{
						path: 'new-dashboard',
						name: 'NewCSDashboard',
						component: NewCSDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'new-dashboard',
							role_filter: 'customer_service_agent',
						}
					},
					{
						path: 'new-retention-dashboard',
						name: 'NewRetentionDashboard',
						component: NewRetentionDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'new-retention-dashboard',
							role_filter: 'customer_service_agent',
						}
					},
					{
						path: 'unassigned',
						name: 'CSUnassignedList',
						component: CSUnassignedList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'unassigned',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'cs-list',
						name: 'CSList',
						component: CSList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'cs-list',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'loss-prevention',
						name: 'CSLossPreventionList',
						component: CSLossPreventionList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'loss-prevention',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'elavon-complaints',
						name: 'CSElavonComplaintList',
						component: CSElavonComplaintList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'elavon-complaints',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'retention',
						name: 'CSRetentionList',
						component: CSRetentionList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'retention',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'callbacks',
						name: 'CSCallbackList',
						component: CSCallbackList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'callbacks',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'untouched',
						name: 'CSUntouchedTickets',
						component: CSUntouchedTickets,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'untouched',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'tickets-without-a-call',
						name: 'CSTicketsWithoutCallList',
						component: CSTicketsWithoutCallList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'tickets-without-a-call',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'resolved',
						name: 'CSResolvedList',
						component: CSResolvedList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'resolved',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'past-due',
						name: 'CSPastDueList',
						component: CSPastDueList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'past-due',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'urgent',
						name: 'CSUrgentList',
						component: CSUrgentList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'urgent',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'orders',
						name: 'CSOrderList',
						component: CSOrderList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'orders',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'admin-tasks',
						name: 'CSAdminTaskList',
						component: CSAdminTaskList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'admin-tasks',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'request-to-action',
						name: 'CSRequestToActionList',
						component: CSRequestToActionList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'request-to-action',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'taliup-register',
						name: 'CSTaliupRegisterList',
						component: CSTaliupRegisterList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'taliup-register',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'third-attempt-close-request',
						name: 'CSThirdAttemptCloseRequestList',
						component: CSThirdAttemptCloseRequestList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'third-attempt-close-request',
							role_filter: 'customer_service_agent',
						},
					},
				]
            },
			{
				path: 'manage/email-templates/list',
				name: 'ManageCSEmailTemplatesList',
				component: ManageCSEmailTemplatesList,
				meta: {
					requiresAuth: true,
					permission: false,
				},
			},
        ]
    },
];

export default routes;
